<div class="info-tile tile-container" [ngClass]="{clickable: isClickable}" (click)="onTileClick()">
    <div class="key-metric-container">
        <div class="info-body">
            <h2 class="info-value">{{ infoValue }}</h2>
            <p class="info-name">{{ infoName }}</p>
        </div>

        <img class="info-icon" [src]="infoIconSrc" [alt]="infoIconAlt" />
    </div>
</div>
